(() => {
  const key = 'hoobro-recent-products-v1';
  const valid = (entry) => entry && /^\d+$/.test(String(entry.id)) && typeof entry.handle === 'string' && /^[a-z0-9][a-z0-9-]*$/i.test(entry.handle);
  const read = () => {
    try {
      const stored = JSON.parse(localStorage.getItem(key) || '[]');
      if (!Array.isArray(stored)) return [];
      const seen = new Set();
      return stored.filter((entry) => {
        if (!valid(entry) || seen.has(String(entry.id))) return false;
        seen.add(String(entry.id));
        return true;
      }).slice(0, 20);
    } catch (_) {
      return [];
    }
  };
  const current = document.getElementById('HBRecentProduct');
  if (current) {
    try {
      const product = JSON.parse(current.textContent);
      if (valid(product)) {
        const history = read().filter((entry) => String(entry.id) !== String(product.id));
        history.unshift({ id: String(product.id), handle: product.handle, at: Date.now() });
        localStorage.setItem(key, JSON.stringify(history.slice(0, 20)));
      }
    } catch (_) {}
  }

  if (customElements.get('hb-recently-viewed')) return;
  const cards = new Map();
  const fetchCard = (entry) => {
    const url = new URL(`${window.Shopify?.routes?.root || '/'}products/${encodeURIComponent(entry.handle)}`, location.origin);
    url.searchParams.set('view', 'hb-recent-card');
    if (window.Shopify?.theme?.role === 'unpublished') url.searchParams.set('preview_theme_id', window.Shopify.theme.id);
    const cacheKey = url.href;
    if (!cards.has(cacheKey)) {
      cards.set(cacheKey, fetch(url, { credentials: 'same-origin' }).then(async (response) => {
        if (!response.ok) return null;
        const document = new DOMParser().parseFromString(await response.text(), 'text/html');
        const template = document.querySelector('template[data-hb-recent-card]');
        if (!template || template.dataset.productId !== String(entry.id)) return null;
        return template.innerHTML;
      }).catch(() => null));
    }
    return cards.get(cacheKey);
  };

  customElements.define('hb-recently-viewed', class extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('.hb-recent__list');
      this.controls = this.querySelector('.hb-recent__controls');
      this.previous = this.querySelector('[data-recent-previous]');
      this.next = this.querySelector('[data-recent-next]');
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.previous?.addEventListener('click', () => this.move(-1), options);
      this.next?.addEventListener('click', () => this.move(1), options);
      this.list.addEventListener('scroll', () => this.updateControls(), { ...options, passive: true });
      window.addEventListener('storage', (event) => {
        if (event.key === key || event.key === null) this.load();
      }, options);
      window.addEventListener('pageshow', (event) => {
        if (event.persisted) this.load();
      }, options);
      this.resize = new ResizeObserver(() => this.updateControls());
      this.resize.observe(this.list);
      if ('IntersectionObserver' in window && !window.Shopify?.designMode && read().length) {
        this.intersection = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.intersection.disconnect();
          this.load();
        }, { rootMargin: '400px' });
        this.intersection.observe(this.parentElement);
      } else {
        this.load();
      }
    }

    disconnectedCallback() {
      this.abort.abort();
      this.resize.disconnect();
      this.intersection?.disconnect();
      this.version = (this.version || 0) + 1;
    }

    async load() {
      const version = this.version = (this.version || 0) + 1;
      const limit = Math.min(12, Math.max(2, Number(this.dataset.limit) || 8));
      const entries = read().filter((entry) => String(entry.id) !== this.dataset.currentProductId);
      const results = [];
      for (let index = 0; index < entries.length && results.length < limit; index += 3) {
        const batch = await Promise.all(entries.slice(index, index + 3).map(fetchCard));
        if (!this.isConnected || this.version !== version) return;
        results.push(...batch.filter(Boolean));
      }
      if (!this.isConnected || this.version !== version) return;
      this.list.replaceChildren(...results.slice(0, limit).map((html) => {
        const item = document.createElement('li');
        item.className = 'hb-recent__item';
        item.innerHTML = html;
        item.querySelectorAll('[id]').forEach((element) => {
          const oldId = element.id;
          const nextId = `${oldId}-${this.dataset.sectionId}`;
          element.id = nextId;
          item.querySelectorAll('[aria-labelledby]').forEach((label) => {
            label.setAttribute('aria-labelledby', label.getAttribute('aria-labelledby').split(' ').map((id) => id === oldId ? nextId : id).join(' '));
          });
        });
        return item;
      }));
      const empty = this.querySelector('[data-recent-empty]');
      const hasProducts = this.list.children.length > 0;
      if (empty) empty.hidden = hasProducts;
      this.hidden = !hasProducts && !empty;
      this.list.scrollLeft = 0;
      requestAnimationFrame(() => this.updateControls());
    }

    updateControls() {
      const max = this.list.scrollWidth - this.list.clientWidth;
      this.controls.hidden = max <= 2;
      this.previous.disabled = this.list.scrollLeft <= 2;
      this.next.disabled = this.list.scrollLeft >= max - 2;
    }

    move(direction) {
      this.list.scrollBy({ left: direction * this.list.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
  });
})();
